import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, keepLogin) {
  // if (keepLogin) {
    // 保持登录，token在15天内有效
    return Cookies.set(TokenKey, token, { expires: 1 })
  // }
  // 不保持登录，token在session周期内有效
  // return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  localStorage.removeItem('userInfo')
  Cookies.remove(TokenKey)
  // Cookies.remove('userInfo')
  return
}
